import classNames from 'classnames';
import { defaultSchedulingColors } from 'containers/scheduling/constants/constants';
import { DateTime } from 'luxon';
import { calculateTextColorForBackground } from 'utils/styleUtils';
import { IDefaultCalendarEvent } from '../types/CalendarTypes';

export function eventPropGetter<T extends IDefaultCalendarEvent>(
  event: T,
  start: Date | string,
  end: Date | string
): { className?: string; style?: React.CSSProperties } {
  const dayStart = DateTime.local().startOf('day');
  const eventEnd = DateTime.fromJSDate(end as Date);
  const past = eventEnd < dayStart;

  const backgroundColor = event.color ? event.color : defaultSchedulingColors.work;
  const textColor = calculateTextColorForBackground(backgroundColor);

  return {
    style: {
      // if it's null or light use white
      color: textColor === 'dark' ? '#000000' : '#ffffff',
      // make the items in the past transparent
      backgroundColor: past ? backgroundColor + '66' : backgroundColor,
    },
    className: classNames({
      dark: textColor === 'dark',
      light: textColor !== 'dark',
    }),
  };
}
